import React from 'react';

import './index.less';

import { MonetaryValue } from 'ck-core/source/classes/MonetaryValue';

export interface Props {
	value: MonetaryValue;
}

export const DisplayMonetaryValue: React.SFC<Props> = ({ value }) => {
	return (
		<div className="DisplayMonetaryValue">
			<span className="DisplayMonetaryValue__big">{value.formatMajorPart()}</span>
			<span className="DisplayMonetaryValue__small">{value.formatMinorUnits()}</span>
		</div>
	);
};
